export const pressObjOne = {
    title: "Attochron News",
    target: "_blank",

    pressHeader6: "October 6, 2025 - NBC-TV WSLS 10 Covers Attochron's First Sale of Free Space Optical Communications in U.S. Government Contract",
    pressSubheader6: "Attochron is going to market with the World's Only Carrier-Grade Optical Wireless Communications -- a unique FSOC solution... ",
    pressButton6: "Read More",
    pressLink6: "https://www.youtube.com/watch?v=brC0a0UwiTE",

    pressHeader5: "September 8, 2025 - TIA to Establish Free-Space Optical Communications Standard; Attochron to Lead New Working Group",
    pressSubheader5: "Attochron FSOC will work with carriers and vendors to lead the establishment of FSOC standards with TIA's TR-45 committee... ",
    pressButton5: "Read More",
    pressLink5: "https://www.prnewswire.com/news-releases/tia-to-establish-free-space-optical-communications-standard-attochron-to-lead-new-working-group-302549588.html",
    
    pressHeader4: "May 13, 2025 - Photonics.com Podcast 0096 - CLosing Connection Gaps through Free Space Optical Communications - With Tom Chaffee, Jim Olson, and Dr. Wayne Knox (Not paid placement)",
    pressSubheader4: "Free space optical communication could offer high speed connectivity without the need of optical fibers... ",
    pressButton4: "Read More",
    pressLink4: "https://www.photonics.com/Podcast/Closing_Connection_Gaps_through_Free_Space/p5/pc1/pce104",

    pressHeader3: "October 10, 2024 - CNN Article - Lasers could take broadband where fiber optics can't",
    pressSubheader3: "Virginia-based company Attochron says it's ready to launch its own version of free-space optics... ",
    pressButton3: "Read More",
    pressLink3: "https://www.cnn.com/2024/10/09/tech/lasers-fso-internet-attochron-spc/index.html",

    pressHeader2: "September 18, 2024 - FIERCE NETWORK Article - Lumen Technologies likes free space optical tech from Attochron",
    pressSubheader2: "Lumen Technologies is buying free space optical technology from Attochron and says Attochron's ultra short pulsed laser solves... ",
    pressButton2: "Read More",
    pressLink2: 'https://www.fierce-network.com/broadband/lumen-technologies-likes-free-space-optical-tech-attochron',

    pressHeader1: "July 17, 2024 - Attochron Completes $15M Series-A Funding",
    pressSubheader1: "Attochron LLC, the leader in providing carrier-grade optical wireless equipment, has closed $15M in Series A funding with a leading... ",
    pressButton1: "Read More",
    pressLink1: require('../../docs/2024 Attochron - TCR. Inc. PE Series A - Press Release - 090524.pdf'),
}